import { render, staticRenderFns } from "./TeacherPayments.vue?vue&type=template&id=53b111ae&"
import script from "./TeacherPayments.vue?vue&type=script&lang=js&"
export * from "./TeacherPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports